import { MapPin, Clock } from "lucide-react";
import { Reveal, Rise } from "./Reveal";
import GlowButton from "./GlowButton";
import content from "../content";
import { SectionBg } from "./SectionBg";

export default function SummerServeSection() {
  const { summerServe } = content;
  if (summerServe.hidden) return null;

  return (
    <section id="servir" className="relative w-full bg-navy py-28 md:py-36 overflow-hidden" data-testid="summer-serve-section">
      <SectionBg image="/images/missions-3.webp" tint="navy" />
      {summerServe.image && (
        <>
          <img
            src={summerServe.image}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 w-full h-full object-cover opacity-[0.28]"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-navy via-navy/60 to-navy" />
        </>
      )}
      <div className="relative w-full max-w-7xl mx-auto px-6">
        <Reveal className="max-w-3xl mb-16">
          <Rise>
            <p className="eyebrow mb-5">{summerServe.eyebrow}</p>
          </Rise>
          <Rise>
            <h2 className="display text-white text-[clamp(2.25rem,6.5vw,5rem)] mb-7">
              {summerServe.title}
            </h2>
          </Rise>
          <Rise>
            <p className="font-poppins text-ceramic/80 text-base md:text-lg leading-relaxed">
              {summerServe.intro}
            </p>
          </Rise>
        </Reveal>

        {/* Vertical timeline */}
        <Reveal className="relative pl-8 md:pl-0" amount={0.1}>
          <div className="absolute left-[7px] md:left-1/2 md:-translate-x-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-electric via-electric/40 to-transparent" />
          <div className="flex flex-col gap-8 md:gap-12">
            {summerServe.events.map((ev, i) => {
              const alignRight = i % 2 === 1;
              return (
                <Rise
                  key={ev.title}
                  className={`relative md:w-1/2 ${alignRight ? "md:self-end md:pl-12" : "md:self-start md:pr-12 md:text-right"}`}
                >
                  {/* node */}
                  <span
                    className={`absolute top-6 w-4 h-4 rounded-full bg-electric shadow-[0_0_16px_rgba(33,112,232,0.9)] border-2 border-navy -left-[30px] md:left-auto ${
                      alignRight ? "md:-left-[56px]" : "md:-right-[56px]"
                    }`}
                  />
                  <article
                    className="glass card-sweep group relative overflow-hidden p-6 md:p-7"
                    data-testid={`serve-card-${i}`}
                  >
                    <span className="inline-flex items-center rounded-full bg-electric px-4 py-1.5 font-poppins text-sm font-bold tracking-wider text-white shadow-[0_0_16px_rgba(33,112,232,0.5)] mb-4">
                      {ev.date}
                    </span>
                    <h3 className="display text-white text-xl md:text-2xl leading-tight mb-3">
                      {ev.title}
                    </h3>
                    <div className={`flex flex-col gap-1.5 ${alignRight ? "" : "md:items-end"}`}>
                      <p className="inline-flex items-center gap-2 font-poppins text-ceramic/80 text-sm">
                        <MapPin size={15} className="text-electric" /> {ev.place}
                      </p>
                      <p className="inline-flex items-center gap-2 font-poppins text-ceramic/80 text-sm">
                        <Clock size={15} className="text-electric" /> {ev.time}
                      </p>
                    </div>
                  </article>
                </Rise>
              );
            })}
          </div>
        </Reveal>

        <Reveal className="text-center mt-16">
          <Rise>
            <GlowButton href={summerServe.cta.href} variant="blue" testId="summer-serve-cta">
              {summerServe.cta.label}
            </GlowButton>
          </Rise>
        </Reveal>
      </div>
    </section>
  );
}
